module.exports = __webpack_public_path__ + "img/steering-wheel.11006d88.svg";